import { Checkbox, Col, Row } from 'antd';
import React, { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';
import { useGetFormConfig } from '../../../hooks/useFormConfig';
import FormItem from '../FormItem/FormItem';

const FormCheckBox = (props: any): (ReactElement | null) => {
  const { t } = useTranslation();
  const formConfig = useGetFormConfig(props);
  const { disabled, options, checkBoxColSize, key = '', checked, className } = formConfig;
  return <FormItem formConfig={formConfig}>
    <Checkbox.Group disabled={disabled} data-testid={key}>
      <Row>
        {
          options?.map(({ value, name, onChange }: any): (ReactElement | null) => {
            return <Col md={checkBoxColSize} key={value} sm={value}>
              <Checkbox
                className={className}
                data-testid={`${key}-${value}`}
                onChange={onChange}
                checked={checked}
                value={value}>
                {t(`translation:${name}`)}
              </Checkbox>
            </Col>;
          })
        }
      </Row>
    </Checkbox.Group>
  </FormItem>;
};

export default FormCheckBox;
